import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            {contactData.title}
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {contactData.desc}
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div className="flex items-center gap-4 p-5 rounded-2xl bg-background-100 border border-background-200/60">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-xl text-accent-600"></i>
              </div>
              <div className="min-w-0">
                <p className="text-xs text-foreground-400 mb-0.5">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-950 truncate">{contactData.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-5 rounded-2xl bg-background-100 border border-background-200/60">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center shrink-0">
                <i className="ri-wechat-line text-xl text-primary-600"></i>
              </div>
              <div className="min-w-0">
                <p className="text-xs text-foreground-400 mb-0.5">微信公众号</p>
                <p className="text-sm font-medium text-foreground-950 truncate">{contactData.wechat}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}